import Vue from 'vue'

// import LoginModule from '@/components/Modules/LoginModule';
// Vue.component('LoginModule', LoginModule);

import StationsHero from '@/components/Modules/StationsHero';
Vue.component('StationsHero', StationsHero);

import CarDetails from '@/components/Modules/CarDetails';
Vue.component('CarDetails', CarDetails);



// WEBPACK FOOTER //
// ./src/components/Modules/index.js